import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconRestrictToBoundingBox = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 1.4,
	clipRule: "evenodd",
	viewBox: "0 0 1024 1024",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M0 0h1024v1024H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 71.9990502,
			d: "M935.278 646.778v324.96H88.619V125.08h406.198"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 71.9980992,
			d: "M783.708 52.313c4.76-3.998 121.858 216.883 121.858 273.687 0 67.25-54.595 121.859-121.858 121.859-67.251 0-121.859-54.608-121.859-121.859 0-56.804 117.099-277.685 121.859-273.687"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 72.002703,
			d: "M291.999 379.289h205.66M687.189 767.681v-205.66"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 72.0013631,
			d: "M799.37 735.522 687.168 847.724 574.966 735.522M322.445 490.024 210.243 377.822 322.445 265.62"
		})
	]
});
export default SvgIconRestrictToBoundingBox;
